import React from 'react';
import { CtaButton } from './CtaButton';
import { priceToday } from '../data/content';
export function FinalClose() {
  return <section aria-labelledby="cierre" className="w-full bg-ink" data-id="element-27" data-mp="s2cauua19wkz">
      <div className="mx-auto max-w-5xl px-6 py-16 lg:px-10 lg:py-24" data-id="element-28" data-mp="n3j039m4sjoi">
        <h2 id="cierre" className="max-w-2xl font-display text-3xl font-semibold leading-tight text-ivory sm:text-[2.8rem]" data-id="element-29" data-mp="n5vni2anrm8y">
          Tienes dos caminos hoy
        </h2>

        <div className="mt-12 grid grid-cols-1 gap-8 md:grid-cols-2 md:gap-12" data-id="element-30" data-mp="1atn25cjo8bde">
          <div className="flex h-full flex-col border-t border-ivory/20 pt-6" data-id="element-31" data-mp="1avq1in6prgus">
            <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-ivory/45" data-id="element-32" data-mp="161c1g7h3wljs">
              Camino 1
            </p>
            <h3 className="mt-3 font-display text-2xl leading-snug text-ivory/60" data-id="element-33" data-mp="1yj7ng23arkpu">
              Seguir estresándote por cada detalle
            </h3>
            <p className="mt-3 font-sans text-base leading-relaxed text-ivory/45" data-id="element-34" data-mp="1trpmvf56rm5e">
              Y arriesgarte a que tu boda sea “una más”, con silencios incómodos y gente mirando el
              reloj.
            </p>
          </div>

          <div className="flex h-full flex-col border-t-2 border-terracotta pt-6" data-id="element-35" data-mp="sq88rxrb2qio">
            <p className="font-sans text-xs font-semibold uppercase tracking-[0.18em] text-terracotta" data-id="element-36" data-mp="dz97l7ssv494">
              Camino 2
            </p>
            <h3 className="mt-3 font-display text-2xl leading-snug text-ivory" data-id="element-37" data-mp="4ybc5dwfg525">
              Invertir lo que cuesta una cena para dos
            </h3>
            <p className="mt-3 font-sans text-base leading-relaxed text-ivory/70" data-id="element-38" data-mp="91r6g3l0xtbo">
              En un sistema que garantiza diversión, orden y tranquilidad para ti y para tus
              invitados.
            </p>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start gap-5 border-t border-ivory/15 pt-10 sm:flex-row sm:items-center sm:justify-between" data-id="element-39" data-mp="1pe693h667lxd">
          <p className="max-w-md font-display text-2xl leading-snug text-ivory sm:text-3xl" data-id="element-40" data-mp="1ud9408sfsbrm">
            Empecemos a crear la boda de tus sueños.
          </p>
          <CtaButton data-id="element-41" data-mp="1nwzdfwiac5fg">Sí, quiero el Mega Pack por {priceToday}</CtaButton>
        </div>
      </div>
    </section>;
}